import React, { useMemo } from "react";
import { isEqual } from "lodash";

import { Order } from "../../../../../../../services";
import { useTypedSelector } from "../../../../../../../redux/store";
import { useCurrencyGlobalSettings } from "../../../../../../../hooks";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const OrderPriceCellContent: React.FC<OrderPriceCellContent.Props> = ({
	item,
}) => {
	const colors = useTypedSelector((state) => state.settings.colors);
	const currencyGlobal = useCurrencyGlobalSettings();

	const { content, backgroundColor } = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const isColorsEqual = !!(
			item?.cellsForTableSettings?.colors &&
			isEqual(item.cellsForTableSettings.colors, colors)
		);

		const preparedCell = item?.cellsForTable?.[ColumnId.OrderPrice];

		const resolvedCell = isCellsReady && isColorsEqual && preparedCell;

		if (resolvedCell) {
			return {
				...resolvedCell,
				content: `${resolvedCell.price} ${currencyGlobal}`,
			};
		}

		return cellProcessing(item, colors, currencyGlobal);
	}, [item, colors, currencyGlobal]);

	return (
		<CellContentRoot
			alignItems="center"
			backgroundColor={backgroundColor}
			h="100%"
			w="100%"
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace OrderPriceCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default OrderPriceCellContent;
